// extracted by mini-css-extract-plugin
module.exports = {"main-component":"notAllowed_main-component__1gNqC"};